import type { CSS } from '@grupoboticario/flora-react'

export const getValueColorCss = (value: number): CSS => ({
  color: value < 0 ? '$error-standard' : '$success-standard'
})
